import { render, staticRenderFns } from "./custom_fields.vue?vue&type=template&id=c6c8bf00&scoped=true&"
import script from "./custom_fields.vue?vue&type=script&lang=js&"
export * from "./custom_fields.vue?vue&type=script&lang=js&"
import style0 from "./custom_fields.vue?vue&type=style&index=0&id=c6c8bf00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c8bf00",
  null
  
)

export default component.exports